import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

export const setToken = (t) => {
  if (t) localStorage.setItem("skd_token", t);
  else localStorage.removeItem("skd_token");
};
export const getToken = () => localStorage.getItem("skd_token");

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
